exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".room-image[data-v-3a3aeba4]{min-height:210px;max-height:250px;border-top-left-radius:.25rem;border-bottom-left-radius:.25rem}", ""]);

// exports
